<template>
    <div class="aboutShowPage" @scroll="scrollT($event)"  ref="aboutShowPage">
        <div class="title">
            <div class="titleText">{{$t('language.aboutShow')}}</div>
            <div class="titleLine"></div>
        </div>
        <div class="listCon">
             <div class="listItem">
                <div class="titleItem">{{$t('language.PingyaoCity')}}</div>
                <div class="ItemLine"></div>
                <div class="content" v-html="getPipGucheng"></div>
            </div>
            <!-- <div class="listItem">
                <div class="titleItem">{{$t('language.PIPIntro')}}</div>
                <div class="ItemLine"></div>
                <div class="content" v-html="getPipIntroduction"></div>
            </div>
            <div class="listItem" >
                <div class="titleItem">{{$t('language.PIPFootprint')}}</div>
                <div class="ItemLine"></div>

                <div class="content">
                   {{$t('language.pingyaoInfo')}}
                </div>
            </div> -->
           
        </div>
        <div class="footerCon"  ref="footerCon" >
			<div style="padding-top: 5px;padding-bottom: 5px;margin-right: 24px;"><a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 36px;'><img src='../../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a></div>
            <div class="address"><img src="../../assets/image/address.png" alt=""><div>{{$t('language.address_b')}}：山西省/晋中市/平遥县/顺城路/故宫文创</div></div>
            <div class="email"><img src="../../assets/image/email.png" alt=""><div>{{$t('language.emails')}}：{{info.email}}</div></div>
        </div>
        <Fixed :goTop="gotoT"></Fixed>
    </div>
</template>
<script>
import Fixed from '../../components/fixed.vue';
export default {
    name:'aboutShow',
    data(){
        return {
            getPipIntroduction:'',
            getPipGucheng:'',
            getFootprint:'',
            currentPage: 1,
            total:1,
            listInfo:[],
           info:{}
        }
    },
    components:{
       Fixed
    },
    mounted(){
        this.getInfo();
    },
    methods:{
        // 侧边菜单显示
       scrollT(event){
           this.scrollTopH = event.target.scrollTop;
           let fixCon = document.getElementsByClassName("fixed")[0]; 
           if(this.scrollTopH>500){
               fixCon.style.opacity = "1"
           }else{
               fixCon.style.opacity = "0"
           }
       },
       // 顶部
       gotoT(){
          this.$refs.aboutShowPage.scrollTop = 0;
       },
       // 获取初始化数据
       getInfo(){
         this.$fetch('/index/info').then(res => {
            this.info = res.data;
        })
            this.$fetch('Content/getPipIntroduction').then(res => {
                if(res.code == 200){
                    this.getPipIntroduction = res.data.info;
                }
            });
            this.$fetch('Content/getPipGucheng').then(res => {
                if(res.code == 200){
                    this.getPipGucheng = res.data.info;
                }
            });
            var data = {
                page: this.currentPage,
                count: 1
            }
            this.$fetch('Content/getFootprint',data).then(res => {
                if(res.code == 200){
                    let datas = res.data.info;
                    this.currentPage = datas.current_page;
                    this.total = datas.total;
                    this.listInfo = datas.data;
                }
            })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange() {
        this.getInfo();
      }
    }
}
</script>
<style scoped>
.aboutShowPage{
    font-family: Microsoft YaHei;
    overflow: auto;
    height: 80vh;
}
.title{
    margin:38px 0px 30px 191px;
    text-align: left;
}
.titleText{
    font-size: 42px;
    font-weight: bold;
    color: #000000;
    padding-bottom: 14px;
}
.titleLine{
    width: 53px;
    height: 6px;
    background: #000000;
}
.listCon{
    width: 60%;
    /* width: 1145px; */
    margin:0 auto;
}
.listItem{
    padding-bottom: 47px;
}
.titleItem{
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #141212;
}
.ItemLine{
    width: 45px;
    height: 2px;
    background: #060001;
    margin:10px auto;
    margin-bottom: 16px;
}
.content{
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #100F0F;
    line-height: 26px;
}
.ImgList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}
.austrilImg>img{
    width: 32%;
    height: 240px;
    margin-top: 20px;
    /* margin-right: 20px; */
}
.pingyaoImg>img{
   width: 547px;
   height: 365px;
   margin-top: 30px;
}
.titleCon{
    text-align: center;
}

.footerCon{
    width: 100%;
    height: 42px;
   background: rgba(245, 245, 245, 1);
    position: absolute;
    bottom: 0%;
    left:0%;
    font-size: 14px;
    font-weight: bold;
    color: #3D3D3B;
    display: flex;
    justify-content: center;
}
.footerCon>div{
    display: flex;
    align-items: center;
}
.address{
    margin-right: 100px;
}
.address img{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.email img{
    width: 19px;
    height: 14px;
    margin-right: 10px;
}
.block{
   display: flex;
   align-items: center;
   justify-content: center;
   padding-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPage/aboutShow.vue